<form [formGroup]="certAreaAssignmentForm">
  <table>
    <tr>
      <th>TYPE</th>
      <th>AREA NAME</th>
      <th>ATTEMPT</th>
      <th>STATUS</th>
      <th></th>
    </tr>
    @for (c of activeCertProgram.certProgramAreaDTOs; track c) {
      <tr>
        <td>
          {{activeCertProgram.certType }}
        </td>
        <td>
          {{c.areaName}}
        </td>
        <td>
          {{c.attemptType}}
        </td>
        <td>
          {{activeCertProgram.certStatus }}
        </td>
        <td>
          <button mat-button mat-raised-button color="warn" (click)="removeCertArea(c)"
            [disabled]="disableRemoveCertArea" title="Remove: {{c.areaName}}">
            Remove
          </button>
        </td>
      </tr>
    }
    <tr>
      <td>
        <mat-form-field style="width:95%">
          <input type="text" matInput formControlName="certAreaInputControl" [matAutocomplete]="auto" placeholder="Cert Area Name" />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)='certAreaSelected($event)'>
            @for (certAreaOption of filteredCertAreas | async; track certAreaOption) {
              <mat-option [value]="certAreaOption">
                {{certAreaOption.areaName}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </td>
      <td>
        <button mat-button mat-raised-button color="primary" (click)="addProgramCertArea()"
          [disabled]="disableAddCertArea" title="Add certification area">
          Add
        </button>
      </td>
    </tr>
  </table>
</form>